export const isSvgFile = (file: File): boolean => file.type === 'image/svg+xml';
